﻿/* globals NotificacionesLiveDTO */
var jquery = require("jquery");
var HabEvents = require("../../Global/habitaclia-events");
var cookieService = require('../../Global/cookie-service');
var storageService = require('../../Global/storage-service').default;

(function () {
	"use strict";


	var NotificacionesLiveIndex = function (notificacionesLiveDTO) {
	    this.NotificacionesLiveDTO = notificacionesLiveDTO;
	    this.__STORAGE_ITEM = 'livevisiblelist';
		this.$mainBtn = jquery('#js-live-main-btn');
		this.$mainBtnRound = jquery('#js-live-main-btn-round');
		this.$liveContainer = jquery('#js-live-container');
		this.$deleteBtn = jquery('#js-live-delete-btn');
		this.$stopBtn = jquery('#js-live-stop-btn');
		this.$liveList = jquery('#js-live-list');
		this.liveList = document.getElementById('js-live-list');
		this.$liveCounter = jquery('#js-live-counter');
		this.$liveAuxList = jquery('#js-live-list-aux');
		this.liveAuxList = document.getElementById('js-live-list-aux');
		this.numberOfItems = this.$liveList.children().length;
		this.numberOfAux = this.$liveAuxList.children().length;
		this.timerDelete = 1100;
		this.cookieExpiration = 14400000;
		this.$body = jquery('body');
		this.dataToSession;
		this.dataToSessionAux;
		this.firstHour = 6;
		this.numberNotificationsCalls = 100;
		this.countNotificationsCalls = 0;
		this.maxNotifications = 50;
		this.storageService = new storageService(window.sessionStorage);
		this.hasSessionStorage = this.storageService.checkLocalStorage();

		__registerEvents.call(this);
		this.hasNoMoreCookie = false;
        if (cookieService.hasCookie('nomorelive')) {
            this.hasNoMoreCookie = true;
        }
		if (!String.prototype.startsWith) {
		  String.prototype.startsWith = function(searchString, position) {
			position = position || 0;
			return this.indexOf(searchString, position) === position;
		  };
		}
		if (this.hasSessionStorage) {
			__getSessionNotifications.call(this);
		}
	};

	var __initCallAjaxLiveInfo = function () {
	    var self = this;
	    if (this.NotificacionesLiveDTO.notificacionesLiveActivadas === 'true') {
	        setTimeout(function () { __ajaxCallbackGetNotificacionesLive.call(self); }, this.NotificacionesLiveDTO.firstTimeLiveNotifications);
	        setInterval(function () { __ajaxCallbackGetNotificacionesLive.call(self); }, this.NotificacionesLiveDTO.defaultTimeLiveNotifications);
	    }
	};

	var __ajaxCallbackGetNotificacionesLive = function () {
	    var self = this;
	    var actualTime = new Date();
	    this.actualHour = actualTime.getUTCHours();
	    this.numberOfItems = this.$liveList.children().length;
	    if (this.actualHour > this.firstHour && !this.hasNoMoreCookie) {
	        if (this.numberNotificationsCalls > this.countNotificationsCalls && this.maxNotifications > this.numberOfItems) {
	            jquery.ajax({
	                type: "GET",
	                url: self.NotificacionesLiveDTO.UrlAjaxNotificacionesLive,
	                data: self.NotificacionesLiveDTO.NavParamsLista,
	                dataType: "json",
	                success: function (data) { __callBackNotificacionesLive.call(self, data); }
	            });
	            this.countNotificationsCalls = this.countNotificationsCalls + 1;
	        }
	    }
	};

	var __callBackNotificacionesLive = function (data) {
		if (data && data !== "") {
			var dataLiveJson = JSON.parse(data);
			if (dataLiveJson.length > 0) {
				__controllerNewNotifications.call(this, dataLiveJson);
			}
		}
    };

	var __registerEvents = function(){
		var self = this;
		this.$mainBtn.click(function(){
			if(self.$mainBtn.hasClass('live-main-close-btn')){
				__closeLive.call(self);
			}else{
				jquery.publish(HabEvents.EventsEnum.ClickBulletNotificacionesLive);		
				self.$liveContainer.css('opacity', '');
				self.$liveContainer.removeClass('live-container-closed');
				self.$mainBtn.addClass('live-main-close-btn');
				self.$body.css('overflow','hidden');
				self.$body.css('height','100vh');
				jquery('#lista-resultados').css('pointer-events','none');
				var i=0;
				/* jshint ignore:start */
				for(i=0; i < self.$liveList.children().length; i++){
					/* jshint ignore:end */
					var $currentItem = jquery(self.$liveList.children()[i]);
					$currentItem.off().click(function (e) {
						e.preventDefault();
						var $target = jquery(e.target);
						var $parentItem = jquery($target.closest('.live-item'));
						var parentItemId = $parentItem.attr('id');
						var itemDataGTM = $parentItem.data('gtmid');

						if (itemDataGTM && self.hasSessionStorage) {
							__removeItemFromList.call(self, itemDataGTM);
						}
						if ($target.hasClass('live-item-close')) {
						    if ($target.closest('.bg-black-alpha') && itemDataGTM) {
						        cookieService.removeCookie(itemDataGTM);
						        cookieService.setCookie(itemDataGTM, 'closed', self.cookieExpiration);
						        if (parentItemId.startsWith('info')) {
						            jquery.publish(HabEvents.EventsEnum.ClickAnuncioLive, 'alerta-close', itemDataGTM + '-close');
						        } else {
						            jquery.publish(HabEvents.EventsEnum.ClickAnuncioLive, 'listado', itemDataGTM + '-close');
						        }
						    }
							$target.closest('.live-item').remove();
							self.numberOfItems = self.$liveList.children().length;
							if(self.numberOfItems === 0){
								__deleteAll.call(self);
							}
						} else {
							var openURL = $parentItem.data('url');
							if (itemDataGTM) {
							    if (parentItemId.startsWith('info')) {
							        jquery.publish(HabEvents.EventsEnum.ClickAnuncioLive, 'alerta-click', itemDataGTM + '-close');
							    } else {
							        jquery.publish(HabEvents.EventsEnum.ClickAnuncioLive, 'listado', itemDataGTM);
							    }
							}
							document.location.href = openURL;
						}

					});
				/* jshint ignore:start */	
				}
				/* jshint ignore:end */
				jquery.publish(HabEvents.EventsEnum.MostrarAnuncioNotificacionLive, self.numberOfItems);
				
			}
		});
		this.$deleteBtn.click(function () {
			jquery.publish(HabEvents.EventsEnum.EliminarTodasNotificacionesLive);
			__deleteAll.call(self);
		});
		this.$stopBtn.click(function () {
		    jquery.publish(HabEvents.EventsEnum.DejarRecibirNotificacionesLive);
		    cookieService.setCookie('nomorelive', 'true', self.cookieExpiration);
		    self.hasNoMoreCookie = true;
			__deleteAll.call(self);
		});
		this.$mainBtn.bind("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function(){ __resetAnimateMainBtn.call(self); });
		
	};



	var __controllerNewNotifications = function(dataLiveJson){
	    var isLiveOpen = this.$liveContainer.hasClass('live-container-closed');
	    var innerLiveTemplate;
		if(this.hasSessionStorage){
			if(isLiveOpen){
				if(this.dataToSession!== undefined){
					this.dataToSession = this.dataToSession.concat(dataLiveJson);
				}else{
					this.dataToSession=dataLiveJson;
				}
			}else{
				if(this.dataToSessionAux!== undefined){
					this.dataToSessionAux= this.dataToSessionAux.concat(dataLiveJson);
				}else{
					this.dataToSessionAux=dataLiveJson;
				}
			}
		}
		for (var i = 0; i < dataLiveJson.length; i++) {
		    if (dataLiveJson[i].id.startsWith('info')) {
		        if (!cookieService.hasCookie(dataLiveJson[i].id) || cookieService.getCookie(dataLiveJson[i].id) === 'visible') {
		            if (jquery('#' + dataLiveJson[i].id).length > 0) {
		                jquery('#' + dataLiveJson[i].id).remove();
		            }
		            var newAnchor = document.getElementById("{{liveItem}}").cloneNode(true);
		            innerLiveTemplate = newAnchor.innerHTML;
		            innerLiveTemplate = innerLiveTemplate.replace("{{image}}", dataLiveJson[i].html);
		            newAnchor.innerHTML = innerLiveTemplate.replace("{{info}}", '');
		            newAnchor.setAttribute("data-gtmid", dataLiveJson[i].id);
		            newAnchor.setAttribute("data-id", dataLiveJson[i].id);
		            newAnchor.setAttribute("data-url", dataLiveJson[i].href);
		            newAnchor.id = dataLiveJson[i].id;
		            newAnchor.className = dataLiveJson[i].classes;
		            newAnchor.setAttribute("style", "");
		            //this.__liveContainer.insertBefore(newAnchor, this.__liveContainer.firstChild);
		            //$newItem = jquery('#' + dataLiveJson[i].id);
		            if (isLiveOpen) {
		                __insertItemsList.call(this, newAnchor);
		            } else {
		                __insertItemsAuxList.call(this, newAnchor);
		            }
		        }
		    } else {
		        var checkId = "#live-" + dataLiveJson[i].id;
		        if (jquery(checkId).length > 0) {
		            jquery(checkId).remove();
		        }
			    var liveTemplate = document.getElementById("{{liveItem}}").cloneNode(true);
			    liveTemplate.id = "live-" + dataLiveJson[i].id;
			    innerLiveTemplate = liveTemplate.innerHTML;
			    var imageHTML = '<img src="' + dataLiveJson[i].img + '"/>';
			    imageHTML = imageHTML.replace("nodisponible.jpg", "livephoto" + (Math.round((Math.random() * 2) + 1)) + ".jpg");

			    var datosAd = '';
			    if (dataLiveJson[i].price !== "0" && dataLiveJson[i].price !== "99999998") {
				    datosAd += dataLiveJson[i].price + '€';
			    } else if(dataLiveJson[i].price === "0"){
				    datosAd += 'a consultar ';
			    }
			    if (dataLiveJson[i].superficie !== "0") {
				    datosAd += '<span>' + dataLiveJson[i].superficie + 'm<sup>2</sup><span>';
			    }
			    if (dataLiveJson[i].hab !== "0" && dataLiveJson[i].hab !== "-1") {
				    datosAd += dataLiveJson[i].hab + 'hab.';
			    }

			    var dataHTML = '<p>' + datosAd + '</p>';

			    innerLiveTemplate = innerLiveTemplate.replace("{{image}}", imageHTML);
			    liveTemplate.innerHTML = innerLiveTemplate.replace("{{info}}", dataHTML);
			    liveTemplate.href = "/" + dataLiveJson[i].url + "?list=true";
			    liveTemplate.setAttribute("data-gtmid", dataLiveJson[i].id);
			    liveTemplate.setAttribute("data-gtmname", "X-X-X");
			    liveTemplate.setAttribute("data-gtmbrand", "X-X-X");
			    liveTemplate.setAttribute("data-gtmprice", (dataLiveJson[i].price !== "0" ? dataLiveJson[i].price : "consultar"));
			    liveTemplate.setAttribute("data-gtmcategory", (dataLiveJson[i].price !== "0" ? dataLiveJson[i].price : "consultar"));
			    liveTemplate.setAttribute("data-gtmvariant", "X");
			    liveTemplate.setAttribute("data-gtmlist", "busqueda-live");
			    liveTemplate.setAttribute("data-gtmposition", "1");
			    liveTemplate.setAttribute("data-url", liveTemplate.href);
			    liveTemplate.setAttribute("style", "");
			    switch(dataLiveJson[i].tipo){
				    case 'new':
					    liveTemplate.children[1].children[0].classList.remove('ocultar');
					    break;
				    case 'up':
					    liveTemplate.children[1].children[1].classList.remove('ocultar');
					    break;
				    default:
					    liveTemplate.children[1].children[2].classList.remove('ocultar');
			    }
			    if(isLiveOpen){
				    __insertItemsList.call(this, liveTemplate);
			    }else{
				    __insertItemsAuxList.call(this, liveTemplate);
			    }
		    }

		}
		__updateCounter.call(this);
		__controllerMainButton.call(this);
	};

	var __controllerMainButton = function(){
		__updateCounter.call(this);
		if(this.$mainBtn.hasClass('live-main-btn-active')&&this.$liveContainer.hasClass('live-container-closed')){
			__animateMainBtn.call(this);
		}else{
			__showLiveMainBtn.call(this);
		}
		__updateSessionStorage.call(this);
	};

	var __getSessionNotifications = function () {
	    if (this.storageService.itemExist(this.__STORAGE_ITEM)) {
	        var lastListJSON = this.storageService.getItem(this.__STORAGE_ITEM);
			var lastList = JSON.parse(lastListJSON);
			__controllerNewNotifications.call(this, lastList);
		}
	};

	var __updateSessionStorage = function () {
		if(this.hasSessionStorage === true){
		    if (this.storageService.itemExist(this.__STORAGE_ITEM)) {
		        this.storageService.removeItem(this.__STORAGE_ITEM);
			}
			if(this.dataToSession.length > 0){
			    this.storageService.setItem(this.__STORAGE_ITEM, JSON.stringify(this.dataToSession));
			}
		}
	};

	var __removeItemFromList = function (idItem) {
		var numberItemLocal = this.dataToSession.length;
		var newLocalList=[];
		for (var currentItem=0;currentItem < numberItemLocal; currentItem++){
			if(this.dataToSession[currentItem].hasOwnProperty('id')){
				if(this.dataToSession[currentItem].id !== idItem.toString()){
					newLocalList.push(this.dataToSession[currentItem]);
				}
			} 
		}
		this.dataToSession = newLocalList;
		__updateSessionStorage.call(this);
	};

	var __insertItemsList = function(item){
		this.liveList.insertBefore(item, this.liveList.firstChild);
	};

	var __insertItemsAuxList = function(item){
		this.liveAuxList.insertBefore(item, this.liveAuxList.firstChild);
		this.numberOfAux = this.$liveAuxList.children().length;
	};

	var __moveAuxToList = function(){
		var $items = jquery(this.$liveAuxList.children()).clone(true);
		this.$liveList.prepend($items);
		this.numberOfAux = 0;
		this.$liveAuxList.children().remove();
		this.numberOfItems = this.$liveList.children().length;
		if(this.hasSessionStorage && this.dataToSession!== undefined){
			this.dataToSession = this.dataToSession.concat(this.dataToSessionAux);
			this.dataToSessionAux=[];
		}
		__controllerMainButton.call(this);
	};

	var __deleteAll = function(){
		var self = this;
		this.$liveList.addClass('live-list-delete');
		this.numberOfItems = 0;
		setTimeout(function(){
			__closeLive.call(self);
            __resetliveList.call(self);
			__deleteAllItemsList.call(self);
		},this.timerDelete);
	};

	var __deleteAllItemsList = function(){
		this.$liveList.children().remove();
		if(this.hasSessionStorage){
			this.dataToSession = [];
			this.storageService.removeItem(this.__STORAGE_ITEM);
		}
	};

	var __animateMainBtn = function(){
		if(!this.$mainBtn.hasClass('live-main-btn-animation')){
			this.$mainBtn.addClass('live-main-btn-animation');
		}
	};
	var __resetAnimateMainBtn = function(){
		this.$mainBtn.removeClass('live-main-btn-animation');
	};
	var __closeLive = function(){
		var self = this;
		self.$body.css('overflow','');
		self.$body.css('height','auto');
		jquery('#lista-resultados').css('pointer-events','all');
		this.$liveContainer.addClass('live-container-closed');
		this.$mainBtn.removeClass('live-main-close-btn');
		if(this.numberOfItems === 0){
			__hideLivemainBtn.call(this);
		}
		if(this.numberOfAux > 0 && !this.hasNoMoreCookie){
			setTimeout(function(){
				__moveAuxToList.call(self);
			},this.timerDelete+500);
		}
		__updateCounter.call(this);
	};

	var __resetliveList = function(){
		this.$liveList.removeClass('live-list-delete');
	};

	var __showLiveMainBtn = function () {
		jquery.publish(HabEvents.EventsEnum.MostrarBulletNotificacionesLive);
		this.$mainBtn.addClass('live-main-btn-active');
	};

	var __hideLivemainBtn = function () {
		this.$mainBtn.removeClass('live-main-btn-active');
	};	

	var __updateCounter = function(){
		this.numberOfItems = this.$liveList.children().length;
		this.$liveCounter.text(this.numberOfItems);
		if (this.numberOfItems === 0){
			this.$mainBtnRound.css('background-image', '');
		}else{
			var urlBackground = jquery(jquery(this.$liveList.children()[0]).children()[0]).attr('src');
			this.$mainBtnRound.css('background-image', 'url('+urlBackground+')');
		}
	};

	var __setLiveFromTemplate = function (ide, itemHTML, cssclasses, link) {
	    if (!cookieService.hasCookie(ide) || cookieService.getCookie(ide) === 'visible') {
	        var info = [{ id: ide, html: itemHTML, classes: cssclasses, href: link }];
	        cookieService.setCookie(ide, 'visible', this.cookieExpiration);
	        __controllerNewNotifications.call(this, info);
	        if (this.hasSessionStorage) {
	            if (this.dataToSession !== undefined) {
	                this.dataToSession = this.dataToSession.concat(info);
	            } else {
	                this.dataToSession = info;
	            }
	        }
	        __updateSessionStorage.call(this);
	    }
	};

	NotificacionesLiveIndex.prototype = {
		constructor: NotificacionesLiveIndex,
		InitCallAjaxLiveInfo: __initCallAjaxLiveInfo,
		SetLiveFromTemplate: __setLiveFromTemplate,
	};

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = new NotificacionesLiveIndex(NotificacionesLiveDTO);
	}
	else {
		window.NotificacionesLiveIndex = NotificacionesLiveIndex;
	}

}());